import { render, staticRenderFns } from "./MtaInvitation.vue?vue&type=template&id=77f92cb2&scoped=true&"
import script from "./MtaInvitation.vue?vue&type=script&lang=js&"
export * from "./MtaInvitation.vue?vue&type=script&lang=js&"
import style0 from "./MtaInvitation.vue?vue&type=style&index=0&id=77f92cb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f92cb2",
  null
  
)

export default component.exports